import { render } from "./Collapse.vue?vue&type=template&id=34acf3a9"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"
script.render = render

export default script